import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { appAbsPath, showToastMessage, executeLaravelAPI, buttonLoadingClass } from '../Utils';
import '../../../Assets/css/LoginPage.scss';
import logo from '../../../images/logo.svg';
import bgImage from '../../../Assets/img/beyondwalls-portal-bg-new.jpg';
import SubmitButton from '../shared/SubmitButton';

const AdminLogin = ({ onLogin }) => {
    const buttonClass = useRef('theme-btn btn col-12 btn-block btn-primary btn-lg font-weight-medium auth-form-btn');
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({ email: '', password: '' });
    const [buttonClassLoader, setButtonClass] = useState(buttonClass.current);
    const navigate = useNavigate();

    console.log("window.location.origin:", window.location.origin);

    useEffect(() => {
        document.body.classList.add('login-page');
        return () => document.body.classList.remove('login-page');
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleLoginClick = async (e) => {
        e.preventDefault();
        const newErrors = { ...errors };
        let valid = true;

        if (!formData.email.trim()) {
            valid = false;
            newErrors.email = 'Email is required';
        }
        if (!formData.password.trim()) {
            valid = false;
            newErrors.password = 'Password is required';
        }

        if (!valid) {
            setErrors(newErrors);
            return;
        }

        try {
            setButtonClass(`${buttonClass.current} ${buttonLoadingClass}`);
            const payload = { email: formData.email, password: formData.password };
            const response = await executeLaravelAPI('admin-login', payload, 'POST');

            if (response?.status === 200) {
                // Persist auth for admin area
                const token = response.access_token || response?.data?.access_token;
                const user = response.user || response?.data?.user;

                if (token) {
                    localStorage.setItem('bwToken', token);
                }
                if (user) {
                    Cookies.set('userData', JSON.stringify(user), { expires: 2 });
                }
                showToastMessage('You are logged in successfully', 'top-right', 'success');
                if (onLogin) onLogin(response);
                window.location.href = `${window.location.origin}/portaladmin/dashboard`;

            } else {
                showToastMessage('Invalid username or password', 'top-right', 'error');
                setButtonClass(buttonClass.current);
            }
        } catch (error) {
            showToastMessage('Login failed. Please try again.', 'top-right', 'error');
            setButtonClass(buttonClass.current);
        }
    };

    return (
        <div
            className="d-flex align-items-center justify-content-center auth px-0"
            style={{
                minHeight: '100vh',
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#f5f7fb'
            }}
        >
            <div className="row w-100 mx-0">
                <div className="col-lg-4 mx-auto">
                    <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                        <div className="brand-logo mb-5">
                            <img src={logo} alt="BeyondWalls Logo" />
                        </div>
                        <h4>Admin Login</h4>
                        <span className="font-weight-light">Sign in to manage the admin panel.</span>
                        <form onSubmit={handleLoginClick} className="pt-3">
                            <div className="d-flex mb-1 form-group">
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Email"
                                    aria-label="Email"
                                />
                            </div>
                            <div
                                className="text-danger"
                                style={{ minHeight: '20px', lineHeight: '20px', fontSize: '0.875rem', margin: 0 }}
                                aria-live="polite"
                            >
                                {errors.email || ' '}
                            </div>

                            <div className="d-flex mb-1 form-group">
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Password"
                                    aria-label="Password"
                                />
                            </div>
                            <div
                                className="text-danger"
                                style={{ minHeight: '20px', lineHeight: '20px', fontSize: '0.875rem', margin: 0 }}
                                aria-live="polite"
                            >
                                {errors.password || ' '}
                            </div>
                            <div className="mt-4">
                                <SubmitButton
                                    variant="success"
                                    type="submit"
                                    className={buttonClassLoader}
                                    label="SIGN IN"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;

